import { memo as Memo, useMemo } from 'react'

//* Helpers
import { diffForHumans } from 'helpers/_functions'

//* Components
import { Text, CustomLink, Avatar } from 'components/common'

//* Style
import LastCommentsStyle from './style'

const LastComments = Memo((props) => {
    const storeComments = useMemo(() => {
        return props.comments.map((i, k) => {
            return (
                <div className='single-comment flexBoxColumn' key={k}>
                    <div className='top flexBox spaceBetween'>
                        <CustomLink url={`/${i.user.username}`}>
                            <Avatar src={i.user.avatar} />
                        </CustomLink>
                        <div className='info'>
                            <div className='name flexBox spaceBetween'>
                                <CustomLink url={`/${i.user.username}`}>
                                    <Text tag={'h5'} className='h5 PopSemi' text={i.user.name} />
                                </CustomLink>
                                <Text tag={'p'} className='h7 PopReg grey' text={diffForHumans(i.created_at)} />
                            </div>
                            {i.parent ? (
                                <CustomLink className='link flexBox' url={`/feedback/${i.parent.id}`}>
                                    <Text tag={'p'} className='h7 PopReg purple'  >
                                        <span className='darkGrey'>at</span> {i.parent.text}
                                    </Text>
                                </CustomLink>
                            ) : (
                                <CustomLink className='link flexBox' url={`/debate/${i.debate.slug}`}>
                                    <Text tag={'p'} className='h7 PopReg purple' >
                                        <span className='darkGrey'>at</span> {i.debate.title}
                                    </Text>
                                </CustomLink>
                            )}
                        </div>
                    </div>
                    <Text tag={'p'} className='com h6 PopReg' text={i.text} />
                </div>
            )
        })
    }, [props.comments])

    return (
        <LastCommentsStyle className={`flexBoxColumn commments-last ${props.debatePage ? 'inDebate' : ''}`}>
            <Text tag={'p'} className='title h9 PopSemi' text={props.title} />
            {storeComments}
        </LastCommentsStyle>
    )
})

export default LastComments
